<span><a href="https://coreui.io">CoreUI</a> &copy; 2018 creativeLabs.</span>
<span class="ml-auto">Powered by <a href="https://coreui.io/angular">CoreUI for Angular</a></span>